import { getFetch } from '@legacy/utils/fetcher';
import { getPathWithQueries } from '@legacy/utils/url/url';
import { useQuery } from '@tanstack/react-query';
import { IResourcePlannerResult } from '@legacy/apis/types/resourcePlannerAPI';
import { PERSONAL_PLAN_KEY, PERSONAL_PLAN_MSW_KEY } from '../constants';

const PERSONAL_PLAN_MSW_KEY_URL = '/api/v2/resource-planner/personal-plan';

export type PersonalPlanPeriodType = 'day' | 'week' | 'month';

interface IPersonalPlan {
  periodTypes?: PersonalPlanPeriodType;
  periodStartDate?: string;
  periodEndDate?: string;
  expandId?: string;
  expandType?: string;
}

export const getPersonalPlan = ({
  periodTypes = 'day',
  periodStartDate = '',
  periodEndDate = '',
  expandId = '',
  expandType = '',
}: IPersonalPlan): Promise<IResourcePlannerResult> =>
  getFetch({
    path: `${getPathWithQueries(PERSONAL_PLAN_MSW_KEY_URL, {
      periodTypes,
      unitTypes: 'hours',
      periodStartsAt: periodStartDate,
      periodEndsAt: periodEndDate,
      expandId,
      expandType,
    })}`,
    key: PERSONAL_PLAN_MSW_KEY,
  });

export const useGetPersonalPlan = ({
  periodTypes = 'day',
  periodStartDate = '',
  periodEndDate = '',
  expandId = '',
  expandType = '',
}: IPersonalPlan) =>
  useQuery<IResourcePlannerResult, Error>({
    queryKey: [
      PERSONAL_PLAN_KEY,
      periodTypes,
      periodStartDate,
      periodEndDate,
      expandId,
      expandType,
    ],
    queryFn: async () =>
      getPersonalPlan({
        periodTypes,
        periodStartDate,
        periodEndDate,
        expandId,
        expandType,
      }),
  });
